import React, { useState, useEffect, useRef, FC } from 'react';
import { StatOptions } from 'fs';
import moment from 'moment';
import { RidersList, FilterDataModel, RiderModel, PaymentModel, RiderFilterDataModel, SortModel, Riders_PackagesModel, Riders_PackagesAuthorizationNumberModel } from '../models/superbit-api-models'
import { SubscribersModel } from '../models/SubscribersModel'
import { Subscriber } from './_Subscriber'
import { SubscriberPopup } from './_SubscriberPopup'
import '../assets/css/subscribers_p0004.css'
import { Menu } from '../_Menu'
import Header from '../Header';
import Footer from '../_Footer'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SubscriberUpdateDetailsPopup } from './popups/_UpdateDetailsPopup';
import { SubscriberUpdatePackagesPopup } from './popups/_UpdatePackagesPopup';
import { ChangeVehiclePopup } from './popups/_ChangeVehiclePopup';

import { SubscriberUpdatePaymentPopup } from './popups/_UpdatePaymentsPopup'
import { SubscriberUpdateEndDatePopup } from './popups/_UpdateEndDatePopup'
import { set } from 'date-fns';
import MessegePopup from './popups/_MessegePopup';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { ClientPopup } from '../clients/_ClientPopup';
import SubscribePopup from './popups/SubscribePopup';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import { add } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { setRidersDataList } from '../app-context/subscribersSlice';
import {buildRidersTree,RidersData} from './SubscriberHelper'
import generalSettings from '../json/general-settings.json';

// type Props = {};
// type State = {
//     data: RidersList | null;
//     pageLoaded: boolean;
//     // Lead: any,
//     filter: RiderFilterDataModel;
//     newRiderId: string | undefined | null;
//     popUpType: string | null;
//     rider?: RiderModel | undefined | null;
//     filterDisplay: any;
//     ridersList: RidersData[];
//     rowsCounter: number;
//     sortBy: any | null;
//     logData: string;
//     copied: boolean;
// };

export interface IFilterDateRefs {
    [key: string]: React.RefObject<DatePicker>;
}

// export class RidersData {
//     rider: RiderModel;
//     all: RiderModel[];
//     oldVersionRiders: RidersData | undefined;



//     constructor(rider: RiderModel, oldVersionRiders: RidersData | undefined, all: RiderModel[]) {
//         this.rider = rider;
//         this.oldVersionRiders = oldVersionRiders;
//         this.all = all;
//     }
// }

type FilterDisplay = {
    createDateTo: Date | null;
    createDateFrom: Date | null;
    startDateTo: Date | null;
    startDateFrom: Date | null;
};

type SubscribersProps = {};


export const Subscribers: FC<SubscribersProps> = () => {

    const dispatch = useDispatch();
    const ridersDataList = useSelector((state: RootState) => state.subscribers.ridersDataList);

    const [data, setData] = useState<RidersList>(new RidersList());
    const [pageLoaded, setPageLoaded] = useState<boolean>(false);
    const [filter, setFilter] = useState<RiderFilterDataModel>(new RiderFilterDataModel());
    const [newRiderId, setNewRiderId] = useState<string | null>(null);
    const [popUpType, setPopUpType] = useState<string | null>('');
    //   const [rider, setRider] = useState(null);
    const [filterDisplay, setFilterDisplay] = useState<FilterDisplay>({
        createDateFrom: null,
        createDateTo: null,
        startDateFrom: null,
        startDateTo: null
    });
    const [ridersList, setRidersList] = useState<RidersData[]>([]);
    const [rowsCounter, setRowsCounter] = useState<number>(0);
    const [sortBy, setSortBy] = useState<{ name: string; direction: string } | null>(null);
    const [logData, setLogData] = useState<string>("");
    const [copied, setCopied] = useState<boolean>(false);

    const [rider, setRider] = useState<RiderModel | null>(null);
    const [popupShow, setPopupShow] = useState<boolean>(false);
    const [showPopUp, setShowPopUp] = useState<boolean>(false);
    const [message, setMessege] = useState<string>('');
    const [popUptitle, setPopUpTitle] = useState<string>('');
    const [popUpContent, setPopUpContent] = useState<string>('');
    const [loading, setLoading] = useState(false);
    const [treatmentsTimeoutId, setTreatmentsTimeoutId] = useState<number | any | null>(undefined);

    const [rennewRider, setRenNewRider] = useState<RiderModel | null>(null);
    const [messageType, setMessageType] = useState<string>('');

    const loggedUser = JSON.parse(localStorage.getItem('loggedUser') || '{}');
    const canViewReports = loggedUser.role == 0 || loggedUser.role == 10;


    const createdStartDateRef = useRef<DatePicker>(null);
    const createdEndDateRef = useRef<DatePicker>(null);
    const subscriberStartDateRef = useRef<DatePicker>(null);
    const subscriberEndDateRef = useRef<DatePicker>(null);


    const subscribersModel = new SubscribersModel();


    const dataSortSettings = {
        sortBy: 'subscriberNumber',
        sortDirection: 'ASC'
    };


    useEffect(() => {
        loadFromStorage()
        loadInit();

    }, []);

    useEffect(() => {
        loadFromStorage()
        // let storageFilter = lastFilterStr && lastFilterStr !== '{}' ? JSON.parse(lastFilterStr) : null;
        // loadInit();
    }, [filter]);

    const loadFromStorage = async () => {
        const lastFilterStr = localStorage.getItem('lastSubscribeFilter');
        //console.log('if filter', JSON.parse(lastFilterStr));
        if (lastFilterStr && lastFilterStr !== '{}') {
            const filterStorage = JSON.parse(lastFilterStr);
            let newFilter = filter;
            if (filterStorage.searchTerm) {
                newFilter.searchTerm = filterStorage.searchTerm
            }
            if (filterStorage.riderStatusType >= 0) {
                newFilter.riderStatusType = filterStorage.riderStatusType;
            }

            if (filterStorage.paymentStatusType >= 0) {
                newFilter.paymentStatusType = filterStorage.paymentStatusType;
            }

            if (filterStorage.createDateFrom) {
                newFilter.createDateFrom = new Date(filterStorage.createDateFrom);
                setStateFilterDisplay("createDateFrom", filterStorage.createDateFrom);
            }
            if (filterStorage.createDateTo) {
                newFilter.createDateTo = new Date(filterStorage.createDateTo);
                setStateFilterDisplay("createDateTo", filterStorage.createDateTo);
            }
            if (filterStorage.startDateFrom) {
                newFilter.startDateFrom = new Date(filterStorage.startDateFrom);
                setStateFilterDisplay("startDateFrom", filterStorage.startDateFrom);
            }
            if (filterStorage.startDateTo) {
                newFilter.startDateTo = new Date(filterStorage.startDateTo);
                setStateFilterDisplay("startDateTo", filterStorage.startDateTo);
            }
            await setFilter(newFilter)

        } else {

            if (!lastFilterStr) {
                const riderFilterData = new RiderFilterDataModel()
                riderFilterData.page = 1;
                console.log('riderFilterData', riderFilterData)
                localStorage.setItem('lastSubscribeFilter', JSON.stringify(riderFilterData))
            }
        }
    }



    // const buildRidersTree = (ridersData: RiderModel[]): RidersData[] => {
    //     const data: RidersData[] = [];
    //     const subscribers = Array.from(new Set(ridersData.map((x) => x.subscriberNumber)));

    //     subscribers.forEach((x) => {
    //         if (x) {
    //             const subscriberRiders = ridersData.filter((y) => y.subscriberNumber === x);
    //             // const rider = subscriberRiders.filter((r) => r.additionNumber === 0);
    //             const smallestAdditionNumber = Math.min(
    //                 ...subscriberRiders.map(r =>
    //                     r.additionNumber !== undefined ? r.additionNumber : Infinity
    //                 )
    //             );
    //             const ridersWithSmallestAddition = subscriberRiders.filter(
    //                 r => (r.additionNumber !== undefined ? r.additionNumber : Infinity) === smallestAdditionNumber
    //             );

    //             if (ridersWithSmallestAddition.length > 0) {
    //                 // let currentRiderData = new RidersData(ridersWithSmallestAddition[ridersWithSmallestAddition.length - 1], undefined, [ridersWithSmallestAddition[ridersWithSmallestAddition.length - 1]]);
    //                 let currentRiderData = new RidersData(ridersWithSmallestAddition[0], undefined, [ridersWithSmallestAddition[0]]);

    //                 const additions = Array.from(new Set(subscriberRiders.map((x) => x.additionNumber)))
    //                     .sort((a, b) => (a === undefined ? 1 : b === undefined ? -1 : a - b));

    //                 // let newAdditions = additions.reverse();

    //                 additions.forEach((addition) => {
    //                     if (addition && addition > 0) {
    //                         const rider = subscriberRiders.filter((r) => r.additionNumber === addition);
    //                         const allVersions = subscriberRiders.filter(
    //                             (r) => r.additionNumber !== undefined && r.additionNumber <= addition
    //                         );
    //                         currentRiderData = new RidersData(rider[0], currentRiderData, allVersions);
    //                     }
    //                 });
    //                 data.push(currentRiderData);
    //             }
    //         }
    //     });

    //     return data;
    // };

    const loadInit = async (newFilter?: any) => {
        let ridersData: RidersList | null = null;
        setLoading(true);

        if (!newFilter) {
            newFilter = filter
        }

        if(ridersDataList && ridersDataList.riders && ridersDataList.riders.length > 0){
            const dataAll = buildRidersTree(ridersDataList.riders);
            setData(ridersDataList as RidersList);
            setRider(null)
            setRidersList(dataAll);
            setLoading(false);
            return;
        }

        
        console.log('newFilter :>> ', newFilter);
        if (newFilter && Object.keys(newFilter).length > 0) {
            ridersData = await subscribersModel.getAllRidersByFilter(newFilter);
        } else {
            ridersData = await subscribersModel.getAllRiders();
            setFilter((prev: any) => ({ ...prev, page: 1 }));
        }
        dispatch(setRidersDataList(ridersData))

        if (ridersData && ridersData.riders) {
            const dataAll = buildRidersTree(ridersData.riders);
            setData(ridersData);
            setRider(null)
            setRidersList(dataAll);
            // setRowsCounter(ridersData.rowsCounter || 0);
        }
        setLoading(false);
    }


    const load = async (newFilter?: any) => {
        let ridersData: RidersList | null = null;
        setLoading(true);

        if (!newFilter) {
            newFilter = filter
        }

        console.log('newFilter :>> ', newFilter);
        if (newFilter && Object.keys(newFilter).length > 0) {
            ridersData = await subscribersModel.getAllRidersByFilter(newFilter);
        } else {
            ridersData = await subscribersModel.getAllRiders();
            setFilter((prev: any) => ({ ...prev, page: 1 }));
        }
        dispatch(setRidersDataList(ridersData))

        if (ridersData && ridersData.riders) {
            const dataAll = buildRidersTree(ridersData.riders);
            setData(ridersData);
            setRider(null)
            setRidersList(dataAll);
            // setRowsCounter(ridersData.rowsCounter || 0);
        }
        setLoading(false);

    };


    // const loadSearchData = async (searchData: string) =>{
    //     let ridersData: RidersList | null = null;
    //     setLoading(true);

    //     if (filter && filter.searchTerm && filter.searchTerm.length > 0 && filter.searchTerm !== undefined) {
    //         ridersData = await subscribersModel.getAllRidersByFilter(filter);
    //     } else {
    //         ridersData = await subscribersModel.getAllRiders();
    //         setFilter((prev: any) => ({ ...prev, page: 1 }));
    //     }

    //     if (ridersData && ridersData.riders) {
    //         const dataAll = buildRidersTree(ridersData.riders);
    //         setData(ridersData);
    //         setRider(null)
    //         setRidersList(dataAll);
    //         // setRowsCounter(ridersData.rowsCounter || 0);
    //     }
    //     setLoading(false);
    // }

    const runFilter = () => {
        // setTimeout(() => {
        //     console.log("callParentFunction runFilter");
        //     load();
        // }, 200);
        load();
    };

    const setStateFilterDisplay = (name: string, value: any) => {
        setFilterDisplay((prev) => ({ ...prev, [name]: value }));
    };

    const setFilterInput = (evt: React.ChangeEvent<HTMLInputElement>) => {
        console.log(' evt.currentTarget.value :>> ', evt.currentTarget.value);
        const searchTerm = evt.currentTarget.value;
        let newFilter = filter;
        // newFilter.searchTerm = searchTerm.length === 0 ? undefined : searchTerm.replace(/\s{2,}/g, " ").trimStart();
        newFilter.searchTerm = searchTerm.length === 0 ? undefined : isNaN(Number(searchTerm)) ? searchTerm.replace(/\s{2,}/g, " ").trimStart() : searchTerm.trim();

        newFilter.page = 1;
        setFilter(newFilter)

        const lastFilterStr = localStorage.getItem('lastSubscribeFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
            savedFilter = JSON.parse(lastFilterStr);
            savedFilter.searchTerm = searchTerm.replace(/\s{2,}/g, " ").trimStart();
            savedFilter.page = 1;
            localStorage.setItem('lastSubscribeFilter', JSON.stringify(savedFilter))
        }


        clearTimeout(treatmentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            load(newFilter);
        }, 1000);
        setTreatmentsTimeoutId(newTimeoutId);

    };



    // onChangeFilterRiderStatusType(evt: any) {
    //     const newStatus = evt.currentTarget.value;
    //     let filter = this.state.filter;
    //     if (!filter) {
    //         filter = new RiderFilterDataModel();
    //     }
    //     if (parseInt(newStatus) >= 0) {
    //         filter['riderStatusType'] = newStatus;
    //     } else {
    //         delete filter['riderStatusType'];
    //     }
    //     this.setState({ filter: filter });
    //     this.runFilter();
    // }
    // make onChangeFilterRiderStatusType as function and pass the value as parameter
    const onChangeFilterRiderStatusType = ({ currentTarget: { value } }: any) => {
        console.log('onChangeFilterRiderStatusType', value)
        const newStatus = parseInt(value);
        console.log('newStatus', newStatus)
        let updatedFilter = filter || new RiderFilterDataModel();

        if (newStatus >= 0) { updatedFilter['riderStatusType'] = newStatus; }
        else { updatedFilter['riderStatusType'] = undefined; }

        const lastFilterStr = localStorage.getItem('lastSubscribeFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
            savedFilter = JSON.parse(lastFilterStr);
            savedFilter.riderStatusType = newStatus;
            localStorage.setItem('lastSubscribeFilter', JSON.stringify(savedFilter))
        }

        setFilter(updatedFilter);
        runFilter();
    };


    const onChangeFilterPaymentStatusType = ({ currentTarget: { value } }: any) => {
        console.log('onChangeFilterPaymentStatusType', value)

        const newStatus = parseInt(value);
        console.log('newStatus', newStatus)
        let updatedFilter = filter || new RiderFilterDataModel();

        if (newStatus >= 0) { updatedFilter['paymentStatusType'] = newStatus; }
        else { updatedFilter['paymentStatusType'] = undefined; }

        const lastFilterStr = localStorage.getItem('lastSubscribeFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
            savedFilter = JSON.parse(lastFilterStr);
            savedFilter.paymentStatusType = newStatus;
            localStorage.setItem('lastSubscribeFilter', JSON.stringify(savedFilter))
        }

        setFilter(updatedFilter);
        runFilter();
    };

    const handleChangeRaw = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Keep only digits (strip /, -, ., spaces, etc.)
        const typedValue = event.target.value.replace(/\D/g, "");

        // If we have exactly 8 digits, parse as DDMMYYYY
        if (typedValue.length === 8) {
            const day = typedValue.slice(0, 2);
            const month = typedValue.slice(2, 4);
            const year = typedValue.slice(4);

            // Convert to "YYYY-MM-DD" to let the JS Date constructor parse it
            const dateString = `${year}-${month}-${day}`;
            const parsedDate = new Date(dateString);

            // Check if parsed date is valid
            if (!isNaN(parsedDate.getTime())) {
                onChangeFilterDate("createDateTo", parsedDate);
            } else {
                onChangeFilterDate("createDateTo", null);
            }
        }
    };

    const onChangeFilterDate = async (filterParamName: string, dateString: Date | null) => {
        const newDate = dateString !== null ? new Date(dateString) : null;
        console.log('onChangeFilterDate', newDate);
        const newFilter = filter;
        (newFilter as any)[filterParamName] = newDate;

        localStorage.setItem('lastSubscribeFilter', JSON.stringify(newFilter))
        await setFilter(newFilter)
        // setFilter((prev: any) => ({ ...prev, [filterParamName]: newDate }));
        setStateFilterDisplay(filterParamName, dateString);

        clearTimeout(treatmentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            runFilter();
        }, 1000);
        setTreatmentsTimeoutId(newTimeoutId);
    };

    const clearFilter = async () => {

        // dispatch(setRidersDataList(
        //     {actionName: null,
        // ))
        dispatch(setRidersDataList({actionName: null,
            allRowsCounter: 0,
            riders: []}));

        const updatedFilter = filter || new RiderFilterDataModel();
        updatedFilter['searchTerm'] = undefined;
        updatedFilter['riderStatusType'] = undefined;
        updatedFilter['paymentStatusType'] = undefined;
        updatedFilter['createDateFrom'] = undefined;
        updatedFilter['createDateTo'] = undefined;
        updatedFilter['startDateFrom'] = undefined;
        updatedFilter['startDateTo'] = undefined;
        updatedFilter['page'] = 1;
        setFilter(updatedFilter);
        localStorage.removeItem('lastSubscribeFilter')

        // setFilter(new RiderFilterDataModel());
        setFilterDisplay({
            createDateFrom: null,
            createDateTo: null,
            startDateFrom: null,
            startDateTo: null
        });
        runFilter();
    };



    const getSortIconClass = (sortOptionName: string) => {
        let className = 'icon sort ';
        className += dataSortSettings && dataSortSettings.sortBy === sortOptionName && dataSortSettings.sortDirection === 'DESC' ? 'desc' : '';
        return className;
    }


    const sortList = (name: string) => {
        let allRiders: RidersList | null;
        let sortByT: any = sortBy ? sortBy : {
            name: '',
            direction: 'ASC'
        };
        const filterT = filter;
        if (sortByT.name === name && sortByT.direction === 'DESC') {
            filterT.sortBy = undefined;
            sortByT = null;
        } else {
            allRiders = data;
            if (sortByT.name !== name) {
                sortByT.name = name;
                sortByT.direction = 'ASC';
            } else {
                if (sortByT.direction === 'DESC') {
                    sortByT.direction = 'ASC';
                } else {
                    sortByT.direction = 'DESC';
                }
            }

            const sort = new SortModel();
            sort.property = sortByT.name;
            sort.sortDirection = sortByT.direction === 'ASC' ? 0 : 1;
            filterT.sortBy = [sort];
        }

        setFilter(filterT);
        setSortBy(sortByT);
        load();
    }


    const openNewRider = () => {
        setNewRiderId("");
        setPopUpType("new");
    };

    const closeRiderPopup = async () => {
        setNewRiderId(null);
        setPopUpType(null);
        setRider(null);
        runFilter();
    };


    const goToPayment = async (rider: RiderModel) => {
        setTimeout(() => {
            if (rider && rider.id) {
                setRider(rider);
                setNewRiderId(rider.id);
                setPopUpType('editPayments');
            }
            runFilter();
        }, 200);
    };


    const goToPackages = async (riderId: string) => {
        setTimeout(() => {
            setNewRiderId(riderId);
            setPopUpType('editPackagess');
            runFilter();
        }, 200);
    }


    const onEditEndDateClick = (rider: RiderModel) => {
        if (rider && rider.id) {
            setRider(rider);
            setNewRiderId(rider.id);
            setPopUpType('editEndDate');

        }
    }


    const onEditClick = (rider: RiderModel) => {
        if (rider && rider.id) {
            setRider(rider);
            setNewRiderId(rider.id);
            setPopUpType('editDetails');
        }
    }

    const OnActiveClick = async (rider: RiderModel) => {
        if (rider && rider.id) {
            const model = await new SubscribersModel().riderActivateRider(rider.id);
            runFilter();
            goToPayment(rider);
        }
    }


    const onUpdateDetailsClick = (rider: RiderModel) => {
        if (rider && rider.id) {
            setRider(rider);
            setNewRiderId(rider.id);
            setPopUpType('editDetails');
        }
    }

    const downloadReportFile = (path: string | null | undefined) => {
        if (!path) {
            return false;
        }
        const apiUrl = localStorage.getItem('apiUrl') || generalSettings.apiUrl;
        const fileUrl = `${apiUrl}${path}`;
        const fileName = path.substring(path.lastIndexOf('/') + 1) || 'Report.xlsx';
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return true;
    }

    const createPaymentReport = async () => {
        setLoading(true);
        try {
            const path = await new SubscribersModel().riderPaymentReport(filter);
            if (!downloadReportFile(path)) {
                setMessageType('error');
                setMessege('שגיאה ביצירת דוח התשלום');
                setPopupShow(true);
            }
        } catch (e) {
            setMessageType('error');
            setMessege('שגיאה ביצירת דוח התשלום');
            setPopupShow(true);
        } finally {
            setLoading(false);
        }
    }

    const createOutputReport = async () => {
        setLoading(true);
        try {
            const path = await new SubscribersModel().riderOutputReport(filter);
            if (!downloadReportFile(path)) {
                setMessageType('error');
                setMessege('שגיאה ביצירת דוח התפוקה');
                setPopupShow(true);
            }
        } catch (e) {
            setMessageType('error');
            setMessege('שגיאה ביצירת דוח התפוקה');
            setPopupShow(true);
        } finally {
            setLoading(false);
        }
    }

    const createServiceReporter = async (rider: RiderModel) => {
        const response = await new SubscribersModel().riderGenerateServiceReporter(rider.id);
        if (response.code == "200") {
            setPopupShow(true);
            setMessege("כתב השירות נוצר בהצלחה!");
        }
    }


    const ShowLog = (rider: RiderModel) => {
        let log = "=== Rider Log ===\n";

        if (rider.riderPackages) {
            rider.riderPackages.forEach((p: Riders_PackagesModel) => {
                const pName = p.riderPackage ? p.riderPackage.name : "Unknown Package";
                log += `\n<div>\n`;
                log += `\n<div class='packageName'>${pName}</div>\n`;
                if (p.riderPackage && p.riderPackage.riderPackageServices) {
                    const services = p.riderPackage.riderPackageServices;

                    if (p.authorizationNumbers) {
                        p.authorizationNumbers.forEach((a: Riders_PackagesAuthorizationNumberModel) => {
                            const authorizationNumber = a.authorizationNumber;
                            let s = services.find(x => x.id === a.riderPackageServiceId);
                            const service = s && s.riderServiceCompany && s.riderServiceCompany.riderService ? s.riderServiceCompany.riderService.title : "Unknown Service";
                            log += `\n<div class='packageContent'>\n`;
                            log += `\n<div class='serviceName'>${service} - ${authorizationNumber}</div>\n`;
                            log += `<div class='log'>${a.log}</div>\n`;
                            log += `</div>\n`;
                        });
                    }
                }

                log += `</div>\n`;
            });
        }

        log += "\n=== End of Log ===\n";

        setLogData(log);
        setCopied(false);
    }

    const clearOfferLog = () => {
        setLogData("");
    }


    const copyToClipboard = async () => {
        var log = logData;
        await navigator.clipboard.writeText(log);
        setCopied(true);
    }

    const onUpdatePackagesClick = (rider: RiderModel) => {
        if (rider && rider.id) {
            setRider(rider);
            setNewRiderId(rider.id);
            setPopUpType('editPackagess');
        }
    }
    const onChangeVehicleClick = (rider: RiderModel) => {
        if (rider && rider.id) {
            setRider(rider);
            setNewRiderId(rider.id);
            setPopUpType('changeVehicle');
        }
    }

    const onUpdatePaymentsClick = (rider: RiderModel) => {
        if (rider && rider.id) {
            setRider(rider);
            setNewRiderId(rider.id);
            setPopUpType('editPayments');
        }
    }


    const onFreezeRiderClick = (rider: RiderModel) => {

    }
    const onNextPageClick = (page: number) => {
        var filterT = filter;
        if (data) {

            if (!filterT) {
                filterT = new RiderFilterDataModel();
            }

            if (filterT) {
                filterT.page = page;

            }
            setFilter(filterT);
            load();
        }
    }

    const onPrevPageClick = (page: number) => {
        var filterT = filter;

        if (!filterT) {
            filterT = new RiderFilterDataModel();
        }

        if (filterT) {
            filterT.page = page;
        }
        setFilter(filterT);
        load();
    }

    const onFirstPageClick = (page: number) => {
        var filterT = filter;

        if (!filterT) {
            filterT = new RiderFilterDataModel();
        }

        if (filterT) {
            filterT.page = 1;
        }
        setFilter(filterT);
        load();
    }

    const onLastPageClick = (page: number) => {
        var filterT = filter;
        var dataT = data;
        if (dataT) {

            if (!filterT) {
                filterT = new RiderFilterDataModel();
            }

            if (filterT) {
                filterT.page = page;
            }
            setFilter(filterT);
            load();
        }

    }

    const onClose = () => {
        setPopupShow(false);
        setMessageType('');
    }

    const showHidePopup = (show: boolean) => {
        setShowPopUp(show);
    }

    return (
        <>
            {showPopUp &&
                <SubscribePopup
                    messageContent={popUpContent}
                    messageTitle={popUptitle}
                    ShowHidePopup={showHidePopup}
                    ClosePopup={() => showHidePopup(false)}
                />
            }
            {popupShow && (
                <MessegePopup
                    message={message}
                    statusMessege={messageType}
                    show={popupShow}
                    onClose={onClose}
                />
            )}
            {newRiderId != undefined && popUpType == 'new' ? (
                <>
                    <SubscriberPopup
                        id={newRiderId}
                        actionType={undefined}
                        rider={rider}
                        ClosePopup={() => closeRiderPopup()}
                        OpenPayment={goToPayment}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}
                        renewRider={false}
                    />
                </>
            ) : ""}


            {rennewRider && popUpType == 'renew' ? (
                <>
                    <SubscriberPopup
                        id={rennewRider.id}
                        actionType={undefined}
                        rider={rennewRider}
                        ClosePopup={() => closeRiderPopup()}
                        OpenPayment={goToPayment}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}
                        renewRider={true}
                        customer={rennewRider.customer}
                        vehicle={rennewRider.vehicle}
                        setMessageType={setMessageType}
                    />
                </>
            ) : ""}


            {newRiderId != undefined && popUpType == 'editDetails' ? (
                <>
                    <SubscriberUpdateDetailsPopup
                        id={newRiderId}
                        actionType={undefined}
                        rider={rider}
                        ClosePopup={() => closeRiderPopup()}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}
                    />
                </>
            ) : ""}
            {newRiderId != undefined && popUpType == 'editEndDate' ? (
                <>
                    <SubscriberUpdateEndDatePopup
                        id={newRiderId}
                        actionType={undefined}
                        rider={rider}
                        ClosePopup={() => closeRiderPopup()}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}
                    />
                </>
            ) : ""}
            {newRiderId != undefined && popUpType == 'editPayments' ? (
                <>
                    <SubscriberUpdatePaymentPopup
                        id={newRiderId}
                        actionType={undefined}
                        rider={rider}
                        ClosePopup={() => closeRiderPopup()}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}
                        setMessageType={setMessageType}

                    />
                </>
            ) : ""}
            {newRiderId != undefined && popUpType == 'editPackagess' ? (
                <>
                    <SubscriberUpdatePackagesPopup
                        id={newRiderId}
                        actionType={undefined}
                        rider={rider}
                        ClosePopup={() => closeRiderPopup()}
                        OpenPayment={goToPayment}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}
                        setMessageType={setMessageType}
                        setPopUpType={setPopUpType}

                    />
                </>
            ) : ""}
            {newRiderId != undefined && popUpType == 'changeVehicle' ? (
                <>
                    <ChangeVehiclePopup
                        id={newRiderId}
                        actionType={undefined}
                        rider={rider}
                        ClosePopup={() => closeRiderPopup()}
                        OpenPackages={goToPackages}
                        setPopupShow={setPopupShow}
                        setMessege={setMessege}

                    />
                </>
            ) : ""}




            <div className="main-content subscribers rtl">
                <Menu activePage='Riders' />
                <div className="center-content">
                    <Header PageName="מנויים" />
                    <section className="main-body">

                        <div className={logData.length > 0 ? "popup-wrapper" : "popup-wrapper hide"}>
                            <section className="popup-window rtl">
                                <div onClick={() => clearOfferLog()} className="close-icon pointer"></div>
                                <div className="popup-content">
                                    <div className="popup-header">
                                        <div className="popup-title">
                                            לוג
                                        </div>
                                    </div>
                                    <div className="popup-body" dangerouslySetInnerHTML={{ __html: logData }}>

                                    </div>
                                    <div className="popup-footer">
                                        <button onClick={() => clearOfferLog()} className="button blue">
                                            סגור
                                        </button>
                                        <button onClick={() => copyToClipboard()} className={copied ? "" : "button blue"}   >
                                            העתק
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <div className="content-header">
                            <div className="flex-centered flex-space-between  mobile-only">
                                <div className="content-main-title">לקוחות</div>
                                <div className="actions flex-centered flex-space-between">
                                    <div className="icon search"></div>
                                    <div className="icon sort"></div>
                                    <div className="icon add"></div>
                                </div>
                            </div>
                            <div className="flex-end desktop-only">
                                <div className="list-actions-row flex-centered flex-space-between">
                                    <div className="filter-row flex-centered flex-space-between">
                                        <div className="filter-input">
                                            <select
                                                value={filter && filter.riderStatusType !== undefined && filter.riderStatusType >= 0 ? filter.riderStatusType : -1}
                                                onChange={(e: any) => onChangeFilterRiderStatusType(e)}
                                            >
                                                <option value="-1">כל הסטטוסים</option>
                                                <option value="0">פעיל</option>
                                                <option value="1">מוקפא</option>
                                                <option value="2">ביטול</option>
                                                <option value="3">עוד לא פעיל</option>
                                                <option value="4">בוטל טרם הפקה</option>
                                                <option value="5">לא נרשם בממסי</option>
                                                <option value="6">לא בתוקף</option>
                                            </select>

                                            {/* <div className="icon down-arrow"></div> */}
                                        </div>
                                        <div className="filter-input">
                                            {/* <input type="text" placeholder="סטטוס תשלום" /> */}
                                            <select
                                                value={filter && filter.paymentStatusType !== undefined && filter.paymentStatusType >= 0 ? filter.paymentStatusType : -1}
                                                onChange={(e: any) => onChangeFilterPaymentStatusType(e)}
                                            // onSelect={(e: any) => onChangeFilterPaymentStatusType(e) }
                                            >
                                                <option value="-1">סטטוס תשלום</option>
                                                <option value="0">לא שולם</option>
                                                <option value="1">שולם</option>
                                            </select>
                                            {/* <div className="icon down-arrow"></div> */}
                                        </div>
                                        <div className="filter-input">
                                            <input
                                                value={filter.searchTerm ? filter.searchTerm : ''}
                                                type="text"
                                                placeholder="חיפוש חופשי..."
                                                onChange={(e: any) => setFilterInput(e)}
                                            />
                                        </div>

                                        <div className="filter-block">
                                            <div className="filter-date-range">
                                                <div className="flex-centered">
                                                    {/* <div className="title">תאריך יצירת מנוי</div> */}
                                                    <div className="filter-input calendar">
                                                        {/* <input type="text" placeholder="תאריך התחלה" />                                              */}
                                                        <CompDatePicker placeholder={"מתאריך יצירה"} value={filterDisplay != null && filterDisplay.createDateFrom != null ? filterDisplay.createDateFrom : null} onChange={(e: any) => onChangeFilterDate("createDateFrom", e)} />

                                                        {/* <div className="icon calendar"></div> */}
                                                    </div>
                                                    <div className="dash"> - </div>
                                                    <div className="filter-input calendar">
                                                        <CompDatePicker placeholder={"עד תאריך יצירה"} value={filterDisplay != null && filterDisplay.createDateTo != null ? filterDisplay.createDateTo : null} onChange={(e: any) => onChangeFilterDate("createDateTo", e)} />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="filter-date-range">
                                                <div className="flex-centered">
                                                    {/* <div className="title">תאריך תחילת מנוי</div> */}
                                                    <div className="filter-input calendar">
                                                        <CompDatePicker placeholder={"מתאריך תחילה"} value={filterDisplay != null && filterDisplay.startDateFrom != null ? filterDisplay.startDateFrom : null} onChange={(e: any) => onChangeFilterDate("startDateFrom", e)} />

                                                    </div>
                                                    <div className="dash"> - </div>
                                                    <div className="filter-input calendar">

                                                        <CompDatePicker placeholder={"עד תאריך תחילה"} value={filterDisplay != null && filterDisplay.startDateTo != null ? filterDisplay.startDateTo : null} onChange={(e: any) => onChangeFilterDate("startDateTo", e)} />


                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="filter-button">
                                            <div className="icon refresh-counter pointer" onClick={(e: any) => clearFilter()}></div>
                                        </div>
                                    </div>
                                    {canViewReports &&
                                        <div className="filter-buttons-block">
                                            <button type="button" className="button blue flex-centered flex-justify-center" onClick={() => createPaymentReport()}>
                                                צור דוח תשלום
                                            </button>
                                            <button type="button" className="button blue flex-centered flex-justify-center" onClick={() => createOutputReport()}>
                                                דוח תפוקה
                                            </button>
                                        </div>
                                    }
                                </div>
                                <div className="content-header-table title-header" >
                                    <div
                                        style={{ minWidth: '60px', maxWidth: '60px', }}>

                                    </div >
                                    <div
                                        style={{ width: '120px' }}
                                        onClick={() => sortList('SubscriberNumber')}>
                                        מס' מנוי
                                        <div className={`icon sort ${sortBy && sortBy.name == 'SubscriberNumber' ? sortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'}`}></div>
                                        {/* <div
                                                className={getSortIconClass('subscriberNumber')}
                                                onClick={(e: any) => { sortList('subscriberNumber') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        style={{ width: '150px' }}
                                        onClick={() => sortList('Customer.FullName')}>
                                        שם לקוח
                                        <div className={`icon sort ${sortBy && sortBy.name == 'Customer.FullName' ? sortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                            }`} style={{ whiteSpace: 'initial' }}></div>
                                        {/* <div
                                                className={getSortIconClass('customer.fullName')}
                                                onClick={(e: any) => { sortList('customer.fullName') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        style={{ width: '120px' }}
                                        // className="cell flex flex-top" 
                                        onClick={() => sortList('Customer.Identifier')}>
                                        ח.פ./ת.ז.
                                        <div className={`icon sort ${sortBy && sortBy.name == 'Customer.Identifier' ? sortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                            }`}></div>
                                        {/* <div
                                                className={getSortIconClass('customer.identifier')}
                                                onClick={(e: any) => { sortList('customer.identifier') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        style={{ width: '120px' }}
                                        // className="cell flex flex-top" 
                                        onClick={() => sortList('Vehicle.LicenseNumber')}>
                                        מס' רכב
                                        <div className={`icon sort ${sortBy && sortBy.name == 'Vehicle.LicenseNumber' ? sortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                            }`}></div>
                                        {/* <div
                                                className={getSortIconClass('vehicle.licenseNumber')}
                                                onClick={(e: any) => { sortList('vehicle.licenseNumber') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        // className="cell flex flex-top"
                                        style={{ width: '250px' }}
                                    >
                                        שם חבילה

                                        {/* <div
                                                className={getSortIconClass('riderPackage.name')}
                                                onClick={(e: any) => { sortList('riderPackage.name') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        style={{ width: '130px' }}
                                        // className="cell flex flex-top date"
                                        onClick={() => sortList('CreatedDate')}>
                                        ת.יצירה
                                        <div className={`icon sort ${sortBy && sortBy.name == 'CreatedDate' ? sortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                            }`}></div>
                                        {/* <div
                                                className={getSortIconClass('createdDate')}
                                                onClick={(e: any) => { sortList('createdDate') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        style={{ width: '130px' }}
                                        // className="cell flex flex-top date"
                                        onClick={() => sortList('StartDate')}>
                                        ת.תחילה
                                        <div className={`icon sort ${sortBy && sortBy.name == 'StartDate' ? sortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                            }`}></div>
                                        {/* <div
                                                className={getSortIconClass('startDate')}
                                                onClick={(e: any) => { sortList('startDate') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        style={{ width: '130px' }}
                                        // className="cell flex flex-top date"
                                        onClick={() => sortList('UpdateEndDate')}>
                                        ת.סיום
                                        <div className={`icon sort ${sortBy && sortBy.name == 'UpdateEndDate' ? sortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                            }`}></div>
                                        {/* <div
                                                className={getSortIconClass('updateEndDate')}
                                                onClick={(e: any) => { sortList('updateEndDate') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        // className="cell flex flex-top status" 
                                        style={{ width: '120px' }}
                                        onClick={() => sortList('RiderStatusType')}>
                                        סטטוס
                                        <div className={`icon sort ${sortBy && sortBy.name == 'RiderStatusType' ? sortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                            }`}></div>
                                        {/* <div
                                                className={getSortIconClass('riderStatusType')}
                                                onClick={(e: any) => { sortList('riderStatusType') }}
                                            ></div> */}
                                    </div>
                                    <div style={{ width: '120px' }}>
                                            הערה
                                    </div>
                                    <div
                                        style={{ width: '120px' }}
                                    // className="cell flex flex-top"
                                    >
                                        מצב תשלום

                                        {/* <div
                                                className={getSortIconClass('paymentStatus')}
                                                onClick={(e: any) => { sortList('paymentStatus') }}
                                            ></div> */}
                                    </div>
                                    <div
                                        // className="cell flex flex-top"
                                        style={{ width: '120px' }}
                                    >
                                        עלות ללקוח

                                        {/* <div
                                                className={getSortIconClass('totalAmount')}
                                                onClick={(e: any) => { sortList('totalAmount') }}></div>*/}
                                    </div>
                                    <div
                                        // className="cell flex flex-top"
                                        style={{ width: '140px' }}
                                        onClick={() => sortList('HandlerId')}>
                                        איש מכירות
                                        <div className={`icon sort ${sortBy && sortBy.name == 'HandlerId' ? (sortBy.direction == 'ASC' ? 'asc' : 'desc') : 'hide'
                                            }`}></div>
                                        {/* <div className="icon sort" onClick={(e: any) => { sortList('handlerName') }}></div>*/}
                                    </div>
                                    <div className="cell flex flex-top actions">
                                        <button className="button blue flex-centered flex-justify-center" onClick={(e: any) => openNewRider()}>
                                            הוסף
                                            <div className="icon add"></div>
                                        </button>
                                    </div>
                                </div >
                            </div >
                        </div >
                        <div className="content-body subscribers-list">
                            <>
                                {ridersList != null ? ridersList.map((item: RidersData, index: number) => {
                                    var rider = item.rider;
                                    return (

                                        <Subscriber
                                            data={rider}
                                            all={item.all}
                                            LastVersion={item.oldVersionRiders}
                                            key={index}
                                            isChild={false}
                                            OnEditClick={() => onEditClick(rider)}
                                            OnActiveClick={() => OnActiveClick(rider)}
                                            onEditEndDateClick={() => onEditEndDateClick(rider)}
                                            onUpdateDetailsClick={() => onUpdateDetailsClick(rider)}
                                            onUpdatePackagesClick={() => onUpdatePackagesClick(rider)}
                                            onChangeVehicleClick={() => onChangeVehicleClick(rider)}
                                            onUpdatePaymentsClick={() => onUpdatePaymentsClick(rider)}
                                            createServiceReporter={() => createServiceReporter(rider)}
                                            onShowLogClick={(rider: RiderModel) => ShowLog(rider)}
                                            setRenNewRider={setRenNewRider}
                                            setPopUpType={setPopUpType}
                                        ></Subscriber>
                                    )
                                }) : ""}
                            </>
                            {loading && (
                                <PleaseWaitLayer />
                            )}


                        </div >
                    </section >

                    <Footer allRowsDataNumber={data.allRowsCounter} AllRowsCounter={data && data.allRowsCounter ? Math.ceil(data.allRowsCounter / 50) : 0} rowsInPage={50} currentPage={filter.page ? filter.page : 1}
                        onFirstPageClick={(number: number) => onFirstPageClick(number)}
                        onLastPageClick={(number: number) => onLastPageClick(number)}
                        onNextPageClick={(number: number) => onNextPageClick(number)}
                        onPrevPageClick={(number: number) => onPrevPageClick(number)}
                    />

                </div >
            </div >
        </>


    );

}

